import * as React from 'react';
import { connect } from 'react-redux';
import TextControle from './controls/TextControle';
import ColoreControle from "./controls/ColoreControle";
import CustomizeControle from "./controls/CustomizeControle";
import SoundtrackControle, {SoundtrackControleComponent} from "./controls/SoundtrackControle";

class ContrilsBlockComponent extends React.Component {
	state = {};

	constructor(props) {
		super(props);
	}
	controls = {
		textcontrol : <TextControle/>,
		color : <ColoreControle/>,
		customizecontrol : <CustomizeControle/>,
		soundcontrol : <SoundtrackControle/>
	}
	render() {
		const {ui} = this.props;
		return (
			<div className={'gloop-controls-block'}>
				{this.controls[ui.activeTab]}
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		ui: state.ui
	};
}
const ContrilsBlock = connect(mapStateToProps)(ContrilsBlockComponent)
export default ContrilsBlock;
